export enum PurchaseItemType {
    Adhesives  = "adhesive",
    Buyers = "buyers",
    BottleSizes = "bottleSize",
    BottlesPerUnits = "bottlesPerUnit",
    CapsuleQualities = "capsuleQualities",
    CartonExternalBoards = "cartonExternalBoards",
    CartonPrintings = "cartonPrintings",
    CartonTypes = "cartonTypes",
    Certifications = "certifications",
    DecorationTypes = "decorationTypes",
    GiftBoxTypes = "giftBoxType",
    GlassHues = "glassHues",
    LabelTypes = "labelTypes",
    Linears = "linear",
    Materials = "materials",
    SubMaterialTypes = "subMaterial",
}
